import { render, staticRenderFns } from "./verLlamado.vue?vue&type=template&id=98f9b63e&scoped=true"
import script from "./verLlamado.vue?vue&type=script&lang=js"
export * from "./verLlamado.vue?vue&type=script&lang=js"
import style0 from "./verLlamado.vue?vue&type=style&index=0&id=98f9b63e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f9b63e",
  null
  
)

export default component.exports